"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _downshift = _interopRequireDefault(require("downshift"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select2 = function Select2(_ref) {
  var options = _ref.options,
      _onChange = _ref.onChange,
      renderLabel = _ref.renderLabel,
      renderSelected = _ref.renderSelected,
      renderPlaceholder = _ref.renderPlaceholder,
      filter = _ref.filter,
      listComponent = _ref.listComponent,
      indexer = _ref.indexer,
      children = _ref.children,
      placeholder = _ref.placeholder,
      downshiftProps = _ref.downshiftProps;
  return _react["default"].createElement(_downshift["default"], _extends({
    onChange: function onChange(selection) {
      return _onChange(selection);
    },
    itemToString: function itemToString(item) {
      return item ? item.value : "";
    }
  }, downshiftProps), function (_ref2) {
    var getToggleButtonProps = _ref2.getToggleButtonProps,
        getItemProps = _ref2.getItemProps,
        getLabelProps = _ref2.getLabelProps,
        getRootProps = _ref2.getRootProps,
        isOpen = _ref2.isOpen,
        inputValue = _ref2.inputValue,
        highlightedIndex = _ref2.highlightedIndex,
        selectedItem = _ref2.selectedItem,
        selectItem = _ref2.selectItem,
        clearSelection = _ref2.clearSelection,
        openMenu = _ref2.openMenu,
        closeMenu = _ref2.closeMenu,
        toggleMenu = _ref2.toggleMenu,
        rest = _objectWithoutProperties(_ref2, ["getToggleButtonProps", "getItemProps", "getLabelProps", "getRootProps", "isOpen", "inputValue", "highlightedIndex", "selectedItem", "selectItem", "clearSelection", "openMenu", "closeMenu", "toggleMenu"]);

    return _react["default"].createElement(SWrapper, getRootProps({
      refKey: "innerRef"
    }), renderLabel && renderLabel(getLabelProps), selectedItem ? renderSelected(selectedItem, getToggleButtonProps, {
      isOpen: isOpen,
      clearSelection: clearSelection,
      openMenu: openMenu,
      closeMenu: closeMenu,
      toggleMenu: toggleMenu
    }) : renderPlaceholder(getToggleButtonProps), isOpen ? children({
      options: options,
      getItemProps: getItemProps,
      highlightedIndex: highlightedIndex,
      selectedItem: selectedItem,
      selectItem: selectItem,
      toggleMenu: toggleMenu
    }) : null);
  });
};

var SWrapper = function SWrapper(_ref3) {
  var innerRef = _ref3.innerRef,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["innerRef", "children"]);

  return _react["default"].createElement(Wrapper, _extends({
    ref: innerRef
  }, rest), children);
};

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Select2__Wrapper",
  componentId: "sc-11uukbz-0"
})(["position:relative;"]);

Select2.propTypes = {
  onChange: _propTypes["default"].func,
  children: _propTypes["default"].func,
  renderLabel: _propTypes["default"].func,
  renderSelected: _propTypes["default"].func,
  renderGroupHeader: _propTypes["default"].func,
  groupBy: _propTypes["default"].string,
  options: _propTypes["default"].array,
  placeholder: _propTypes["default"].string,
  downshiftProps: _propTypes["default"].object
};
var _default = Select2;
exports["default"] = _default;